import COSInvoiceListContainer from "./COSInvoiceList.container";

export default COSInvoiceListContainer;
